'use strict';

$(document).ready(function () {
    const option = {
        lazyLoad: 'ondemand',
        dots: false,
        arrows: false,
        slidesToShow: 1,
        speed: 400,
    };
    const $tagsSlick = $('.sustainability-tags-pdp-details');
    const $document = $(document);
    $tagsSlick.slick(option);

    let $navList = $('.sustainability-tags-section .icon-wrapper');
    let selectedIndex = 0;
    let beforeHoverIndex = 0;
    let tagInteraction = 0;
    let leaveTimer;
    var isHovering;

    $document.on('click', '.product-tile-pd .sustainability-tags .icon-wrapper, .product-tile .sustainability-tags .icon-wrapper', function (e) {
        e.preventDefault();
        let $tag = $(this);
        var $modalDialog = $('#sustainabilityModal .modal-dialog');
        $modalDialog.empty();
        let actionUrl = $tag.data('action');
        let pid = $tag.closest('.sustainability-tags').data('pid');
        let targetSlide = $tag.data('target-tag');

        $.spinner().start();

        $.ajax({
            url: actionUrl,
            type: 'get',
            data: { pid: pid },
            success: function (result) {
                let $html = $('<div>').append($.parseHTML(result.renderedTemplate));
                let $newModalData = $html.find('.modal-dialog');
                $modalDialog.html($newModalData.html());

                $('.sustainability-modal .sustainability-details-carousel').on('init reInit afterChange', function (event, slick) {
                    let $thisSlick = $(this);
                    if ($thisSlick.hasClass('slick-initialized')) {
                        let index = $(`.sustainability-details-component[data-details-tag=${targetSlide}]`).closest('.slick-slide').data('slick-index');
                        if ((event.type === 'init' || event.type === 'reInit') && index !== undefined) {
                            setTimeout(() => {
                                $thisSlick.slick('slickGoTo', index);
                                $('#sustainabilityModal').modal('show');
                            }, 0);
                        }
                        $('.sustainability-modal .paging-info').text(slick.slickCurrentSlide() + 1 + '/' + slick.slideCount);
                    }
                });
                $('.sustainability-modal .sustainability-details-carousel').each(function () {
                    let $this = $(this);
                    if (!$this.hasClass('slick-initialized')) {
                        $this.slick({
                            dots: false,
                            arrows: true,
                            infinite: true,
                            lazyLoad: 'ondemand',
                            slidesToShow: 1,
                            speed: 400,
                            touchThreshold: 100,
                            slidesToScroll: 1,
                            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-icon"></i></button>',
                            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-icon"></i></button>',
                        });
                    }
                });
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });
    });

    // Handle icon click
    $document.on('click', '.sustainability-tags-section .icon-wrapper', function () {
        // Update icon selection
        $navList.removeClass('selected');
        $(this).addClass('selected');

        selectedIndex = $(this).index();
        beforeHoverIndex = selectedIndex;
        $tagsSlick.slick('slickGoTo', selectedIndex, false);
    });

    $document.on('mouseenter', '.sustainability-tags-section .icon-wrapper', function () {
        if (app.isDesktop()) {
            clearTimeout(leaveTimer);
            const hoverIndex = $(this).index();
            isHovering = true;
            $tagsSlick.slick('slickGoTo', hoverIndex);
            $navList.removeClass('selected');
            $(this).addClass('selected');
            tagInteraction += 1;
        }
    });

    $(document).on('mouseleave', '.sustainability-tags-section', function (e) {
        if (app.isDesktop()) {
            leaveTimer = setTimeout(() => {
                const relatedTarget = e.relatedTarget;
                const hasHoveredOtherIcon = relatedTarget && $(relatedTarget).closest('.icon-wrapper').length;

                if (!hasHoveredOtherIcon) {
                    $tagsSlick.slick('slickGoTo', selectedIndex);
                    $navList.removeClass('selected');
                    $('.sustainability-tags-section .icon-wrapper').first().addClass('selected');
                }
            }, 200);
        }
    });

    // After slide changes — update selected icon
    $document.on('afterChange', '.sustainability-tags-pdp-details', function (event, slick, currentSlide) {
        if (!isHovering) {
            $navList.removeClass('selected');
            $navList.eq(currentSlide).addClass('selected');
            setTimeout(() => {
                if (tagInteraction % 2 === 0) {
                    selectedIndex = beforeHoverIndex;
                    $navList.removeClass('selected');
                    $navList.eq(selectedIndex).addClass('selected');
                }
            }, 300);
        }
    });

    $document.on('click', '.pdp-attr-group-wrapper .sustainability-tags .icon-wrapper', function () {
        // Scroll to the PDP details section
        $('html, body').animate(
            {
                scrollTop: $('.sustainability-tags-pdp-wrapper').offset().top - 120,
            },
            300
        );

        // Find and trigger click on matching icon in the lower section
        const targetKey = $(this).data('target-tag');
        $('.sustainability-tags-section .icon-wrapper[data-icon-key="' + targetKey + '"]').trigger('click');
    });
});
